// extracted by mini-css-extract-plugin
module.exports = {"root":"Y_b9","error":"Y_j"};